import * as React from 'react';

function defaultBuildSignature(obj) {
  return JSON.stringify(obj, (_, v) => (Array.isArray(v) ? [...v].sort() : v));
}

export function useFilterPagination({
  filters,
  buildSignature = defaultBuildSignature,
  pageIndex: controlledPage,
  setPageIndex: setControlledPage,
  initialPage = 1,
}) {
  const [uncontrolledPage, setUncontrolledPage] = React.useState(initialPage);

  const signature = React.useMemo(
    () => buildSignature(filters),
    [filters, buildSignature],
  );

  const prevSignatureRef = React.useRef(signature);
  const filtersChanged = prevSignatureRef.current !== signature;

  const pageIndex = controlledPage ?? uncontrolledPage;
  const setPageIndex = setControlledPage ?? setUncontrolledPage;

  const pageForQuery = filtersChanged ? 1 : pageIndex;

  React.useEffect(() => {
    if (filtersChanged) {
      setPageIndex(1);
      prevSignatureRef.current = signature;
    }
  }, [filtersChanged, signature, setPageIndex]);

  return { pageIndex, setPageIndex, pageForQuery, filtersChanged, signature };
}
